// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Config from "../../../../../Config.bs.js";
import * as SendSmsRepo from "./SendSmsRepo.bs.js";
import * as DummySendSmsRepo from "./DummySendSmsRepo.bs.js";

function getRepo(param) {
  var match = Config.Env.getEnv(undefined);
  if (match >= 2) {
    return DummySendSmsRepo.SendSmsRepo;
  } else {
    return SendSmsRepo.SendSmsRepo;
  }
}

export {
  getRepo ,
  
}
/* Config Not a pure module */
